import React from 'react';
import Div from "@jumbo/shared/Div";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { dateFormat } from '../utils/dateFunctions';
import { getAPIData } from '../utils/apiFunction';

const ETransferDisplay = (props) => {
    const transferId = props.transferId;
    const [transfer, setTransfer] = React.useState(null);

    React.useEffect(() => {
        if (props.transferId) {
            getAPIData('/Transfers/Get/' + props.transferId, setTransfer);
        }
    }, [props.transferId]);
    React.useEffect(() => {
        //does the transfer have multiple leases
        //multiple crops


    }, [transfer])
    console.log(transfer);

    return <Div>
        {transfer ? <Grid container spacing={0} mb={1}>
            <Grid item xs={12} >
                <Typography variant={"h3"}>{transfer.otr}</Typography>
            </Grid>
            <Grid item xs={12} >
                <Typography variant={"h4"}>From: {transfer.source?.myobid}</Typography>
            </Grid>
            <Grid item xs={12} >
                <Typography variant={"h4"}>To: {transfer.destination?.description} </Typography>
            </Grid>
            <Grid item xs={12} >
                <Typography variant={"h5"}>{dateFormat(transfer.dateReady)}</Typography>
            </Grid>
            <Grid item xs={12} >
                <Typography variant={"h5"}>PRN: {transfer.prn}</Typography>
            </Grid>
            <Grid item xs={12} >
                <Typography variant={"h5"}>Harvest Date: {dateFormat(transfer.harvestDate)}</Typography>
            </Grid>
            <br />
            <br />
            {(() => {
                const lines = transfer.coreTransferLines || [];
                const groups = new Map();
                const singles = [];
                const order = [];
                lines.forEach((ln, idx) => {
                    const mgid = ln?.mixedGroupId ?? ln?.MixedGroupId ?? null;
                    if (mgid) {
                        if (!groups.has(mgid)) {
                            groups.set(mgid, { items: [], firstIndex: idx });
                            order.push({ key: `g:${mgid}`, type: 'group', index: idx });
                        }
                        groups.get(mgid).items.push(ln);
                    } else {
                        const key = `s:${idx}`;
                        singles.push({ key, item: ln, index: idx });
                        order.push({ key, type: 'single', index: idx });
                    }
                });

                // Build combined list preserving first occurrence order
                const renderItems = [];
                order.sort((a, b) => a.index - b.index).forEach(entry => {
                    if (entry.type === 'single') {
                        const s = singles.find(x => x.key === entry.key);
                        if (!s) return;
                        const line = s.item;
                        renderItems.push({
                            key: entry.key,
                            crop: line.crop,
                            description: line?.stockItem?.description,
                            bags: Number(line.bags) || 0,
                            bins: Number(line.bins) || 0,
                            quantity: Number(line.quantity) || 0,
                            isGroup: false
                        });
                    } else {
                        const g = groups.get(entry.key.slice(2));
                        if (!g || g.items.length === 0) return;
                        const base = g.items[0];
                        const totalBags = g.items.reduce((p, c) => p + (Number(c.bags) || 0), 0);
                        const totalBins = g.items.reduce((p, c) => p + (Number(c.bins) || 0), 0);
                        const totalQty = g.items.reduce((p, c) => p + (Number(c.quantity) || 0), 0);
                        const desc = (base?.stockItem?.description ? `${base.stockItem.description} (Mixed Group)` : 'Mixed Group');

                        // Build grade breakdown percentages for the mixed group
                        let breakdownText = '';
                        if (totalQty > 0) {
                            const labelFor = (ln) => (
                                ln?.mixedGrades?.name ||
                                ln?.stockItem?.mixedGrades?.name ||
                                ln?.grade?.name ||
                                ln?.stockItem?.grade?.name ||
                                ln?.gradeName ||
                                ln?.stockItem?.description ||
                                'Grade'
                            );
                            const byLabel = new Map();
                            g.items.forEach(ln => {
                                const key = labelFor(ln);
                                const qty = Number(ln.quantity) || 0;
                                byLabel.set(key, (byLabel.get(key) || 0) + qty);
                            });
                            const entries = Array.from(byLabel.entries());
                            // Sort by quantity desc for readability
                            entries.sort((a, b) => b[1] - a[1]);
                            const rawPerc = entries.map(([, q]) => (q / totalQty) * 100);
                            let rounded = rawPerc.map(p => Math.round(p));
                            // Adjust to ensure sum = 100
                            const diff = 100 - rounded.reduce((p, c) => p + c, 0);
                            if (diff !== 0 && rounded.length > 0) {
                                // Nudge the largest entry by diff
                                const idxMax = rounded.reduce((imax, v, i, arr) => (v > arr[imax] ? i : imax), 0);
                                rounded[idxMax] = Math.max(0, rounded[idxMax] + diff);
                            }
                            breakdownText = entries.map(([label], i) => `${label} ${rounded[i]}%`).join(' • ');
                        }
                        renderItems.push({
                            key: entry.key,
                            crop: base.crop,
                            // Replace stock item description with breakdown for mixed groups when available
                            description: (breakdownText && breakdownText.length > 0) ? breakdownText : desc,
                            bags: totalBags,
                            bins: totalBins,
                            quantity: totalQty,
                            isGroup: true
                        });
                    }
                });

                return renderItems.map(it => (
                    <Grid item xs={12} key={it.key}>
                        <Typography variant={"h6"}>{it.crop}</Typography>
                        <Typography variant={"h6"}>{it.description}{(it.bags > 0 ? (` - ${it.bags} Bags`) : '')}{(it.bins > 0 ? (` - ${it.bins} Bins`) : '')} - {it.quantity} doz</Typography>
                    </Grid>
                ));
            })()}
        </Grid> : null}
    </Div>
}

export default ETransferDisplay;
